import AuthRequiredModal from './AuthRequiredModal';

export default AuthRequiredModal;
